import React, { useEffect, useState, useContext } from 'react'

import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Skeleton from '@material-ui/lab/Skeleton'
import { SocketContext } from '../../context/Socket/SocketContext.js'

import moment from 'moment'

import Rating from '@material-ui/lab/Rating'

import { useStyles } from './style'

export function RatingBox({ rating }) {
  const ratingTrunc = rating === null ? 0 : Math.trunc(rating)
  return <Rating value={ratingTrunc} max={5} readOnly />
}

export default function TableAttendantsStatus(props) {
  const { loading, attendants: loadedAttendants } = props
  const classes = useStyles()
  const socketManager = useContext(SocketContext)
  const [attendants, setAttendants] = useState(loadedAttendants || [])

  const updateStatus = (data) => {
    const { userId, online } = data
    setAttendants((prevAttendants) =>
      prevAttendants.map((attendant) =>
        attendant.id === userId ? { ...attendant, online } : attendant
      )
    )
  }

  useEffect(() => {
    if (loadedAttendants) {
      setAttendants(loadedAttendants)
    }
  }, [loadedAttendants])

  useEffect(() => {
    const socket = socketManager.GetSocket()

    socket.on('userOnlineChange', updateStatus)

    return () => {
      socket.disconnect()
    }
  }, [socketManager])

  function renderList() {
    return attendants.map((a, k) => (
      <TableRow
        key={k}
        className={k % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}
      >
        <TableCell>{a.name}</TableCell>
        <TableCell align="center" className={classes.pointer}>
          <RatingBox rating={a.rating} />
        </TableCell>
        <TableCell align="center">{a.tickets}</TableCell>
        <TableCell align="center">{a.openCount}</TableCell>
        <TableCell align="center">{a.closeCount}</TableCell>
        <TableCell align="center">{formatTime(a.avgWaitTime, 2)}</TableCell>
        <TableCell align="center">{formatTime(a.avgSupportTime, 2)}</TableCell>
        <TableCell align="center">
          <div className={classes.statusContainer}>
            <span
              className={
                a.online ? classes.statusDotOnline : classes.statusDotOffline
              }
            ></span>
            <span className={classes.statusText}>
              {a.online ? 'Online' : 'Offline'}
            </span>
          </div>
        </TableCell>
      </TableRow>
    ))
  }

  function formatTime(minutes) {
    return moment().startOf('day').add(minutes, 'minutes').format('HH[h] mm[m]')
  }

  return !loading ? (
    <TableContainer component={Paper}>
      <Table className={classes.table}>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell align="center">Avaliações</TableCell>
            <TableCell align="center">Total</TableCell>
            <TableCell align="center">Acontecendo</TableCell>
            <TableCell align="center">Finalizados</TableCell>
            <TableCell align="center">T.M. de Espera</TableCell>
            <TableCell align="center">T.M. de Atendimento</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderList()}</TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Skeleton variant="rect" height={150} />
  )
}
